import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { getNotificationSenderUser } from 'store/actions';

const initialState = {
    user: {},
    error: null,
    loading: false
};

const notificationSenderUserStart = (state, action) => {
    /*
    console.log('notificationLoadStart');
    console.log(state);
    console.log(action);
    */
    return updateObject( state, { error: null, loading: true } );
}

const notificationSenderUserSuccess = (state, action) => {
    console.log('notificationSenderUserSuccess');
    console.log(state);
    console.log(action);

    return updateObject( state, {
        user: action.user,
        loading: false
    });
}

const notificationSenderUserFail = (state, action) => {
    /*
    console.log('notificationLoadFail');
    console.log(state);
    console.log(action);
    */
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.NOTIFICATION_SENDER_USER_START: return notificationSenderUserStart(state, action);
        case actionTypes.NOTIFICATION_SENDER_USER_SUCCESS: return notificationSenderUserSuccess(state, action);
        case actionTypes.NOTIFICATION_SENDER_USER_FAIL: return notificationSenderUserFail(state, action);
        default: 
            return state;
    }
}

export default reducer;
